import {
  combineReducers,
  configureStore,
  createAction,
} from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import selectedMealsSlice from "./slices/selectedMealsSlice";
import userSubscriptionInfoSlice from "./slices/userSubscriptionInfo";
import apiStatusSlice from "./slices/apiStatusSlice";
import selectedFieldSlice from "./slices/selectedFieldSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["selectedMeals", "userSubscriptionInfo" , "userFieldsSeleceted"],
};
export const resetStore = createAction("resetStore");
const reducers = {
  selectedMeals: selectedMealsSlice.reducer,
  userSubscriptionInfo: userSubscriptionInfoSlice.reducer,
  userFieldsSeleceted: selectedFieldSlice.reducer,
  apiStatus: apiStatusSlice.reducer,
};

const rootReducer = combineReducers(reducers);

const appReducer = (state, action) => {
  if (action.type === resetStore.type) {
    storage.removeItem("persist:root");
    state = undefined;
  }
  return rootReducer(state, action);
};
const persistedReducer = persistReducer(persistConfig, appReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  devTools: true,
});

export const persistor = persistStore(store);

export default store;
